'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/remark-parse/lib/locate/delete.js
// module id = ./node_modules/remark-parse/lib/locate/delete.js
// module chunks = 0